import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

import { AppComponent } from "./app.component";
import { ApploginComponent } from "./applogin/applogin.component";
import { IndexComponent } from "./index/index.component";
import { AppRoutingModule } from ".//app-routing.module";
import { UserService } from "./services/user.service";
import { KycserviceService } from "./services/kycservice.service";
import { RoutingstateService } from "./services/routingstate.service";
import { PuserserviceService } from "./services/puserservice.service";
import { AssetsService } from "./services/assets.service";
import { PagerserviceService } from "./services/pagerservice.service";
import { WalletsService } from "./services/wallets.service";
import { BankService } from "./services/bank.service";
import { OfframpService } from "./services/offramp.service";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { SessionExpiredInterceptor } from "./interceptors/session-expired.interceptor";
import { ClientIpInterceptor } from "./interceptors/client-ip.interceptor";
import { ClientIpService } from "./services/client-ip.service";
import { AppcustomerlistComponent } from "./appcustomerlist/appcustomerlist.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SimpleNotificationsModule } from "angular2-notifications";
import { AppkycdetailsComponent } from "./appkycdetails/appkycdetails.component";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { TransactionService } from "./services/transaction.service";
import { TransactionsComponent } from "./transactions/transactions.component";
import { FiatTransactionsComponent } from "./fiattransactions/transactions.component";
import { ClipboardModule } from "ngx-clipboard";
import { LoginactivityComponent } from "./loginactivity/loginactivity.component";
import { AdminTransactionsComponent } from "./admin-transactions/admin-transactions.component";

import { ConfigurationService } from "./services/configuration.service";

import { WithdrawComponent } from "./withdraw/withdraw.component";
import { FiatWithdrawComponent } from "./fiatwithdraw/fiatwithdraw.component";
import { OrderComponent } from "./order/order.component";
import { ExchangeService } from "./services/exchange.service";
import { TradingService } from "./services/trading.service";
import { Ng2TelInputModule } from "ng2-tel-input";
import { ManageadminComponent } from "./manageadmin/manageadmin.component";
import { AdminService } from "./services/admin.service";
import { GroupsComponent } from "./groups/groups.component";
import { SidebarComponent } from "./_layout/sidebar/sidebar.component";
import { HeaderComponent } from "./_layout/header/header.component";
import { ContentComponent } from "./_layout/content/content.component";
import { FooterComponent } from "./_layout/footer/footer.component";
import { MobilesidebarComponent } from "./_layout/mobilesidebar/mobilesidebar.component";
import { AnnouncementComponent } from "./announcement/announcement.component";
import { AnnouncementService } from "./services/announcement.service";
import { Globals } from "./app-globals";
import { TradereportComponent } from "./tradereport/tradereport.component";
import { ReportService } from "./services/report.service";
import { AngularDateTimePickerModule } from "angular2-datetimepicker";
import { SecuirtiesComponent } from "./secuirties/secuirties.component";
import { MenupermissionPipe } from "./custompipes/menupermission.pipe";
import { KycplansComponent } from "./kycplans/kycplans.component";
import { SumValuesPipe } from "./custompipes/sum-values.pipe";
import { RECAPTCHA_SETTINGS, RecaptchaModule } from "ng-recaptcha";
import { environment } from "../environments/environment";
import { RecaptchaFormsModule } from "ng-recaptcha/forms";
import { FileService } from "./services/file.service";
import { RichTextEditorAllModule } from "@syncfusion/ej2-angular-richtexteditor";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { TransferComponent } from "./transfer/transfer.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { MaterialModule } from "./material/material.module";
import { ViewsService } from "./services/views.service";
import { ManageAuctionConfigurationComponent } from './manage-auction-configuration/manage-auction-configuration.component'
import { AdmintradereportComponent } from './admintradereport/admintradereport.component';
import { ManageipComponent } from './manageip/manageip.component';
import { CmsComponent } from './cms/cms.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { GeneratePasswordComponent } from './generate-password/generate-password.component';
import { LinkexpireComponent } from './linkexpire/linkexpire.component';
import { ManualkycComponent } from './manualkyc/manualkyc.component';
import { ReferralconfigComponent } from './referralconfig/referralconfig.component';
import { ReferalhistoryComponent } from './referalhistory/referalhistory.component';
import { ReferralbonustransComponent } from './referralbonustrans/referralbonustrans.component';
import { CareersComponent } from './careers/careers.component';
import { CareerService } from "./careers/career.service";
import { ContentManagementComponent } from './content-management/content-management.component';
import { ContentManagementService } from "./content-management/content-management.service";
import { CandidatesComponent } from './candidates/candidates.component';
import { ManageAddressWhitelistComponent } from './manage-address-whitelist/manage-address-whitelist.component';
import { HomeComponent } from './home/home.component';
import { HomeService } from "./home/home.service";
import { AppKycDetailsService } from "./appkycdetails/appkycdetails.service";
import { LedgerComponent } from "./ledger/ledger.component";
import { AppCustomerService } from "./appcustomerlist/appcustomer.service";
import { ClientOrderReportComponent } from "./clientorderreport/clientorderreport.component";
import { MatAutocompleteModule, MatButtonModule, MatCardModule, MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatNativeDateModule, MatPaginatorModule, MatSelectModule, MatSlideToggleModule, MatSortModule, MatTableModule, MatTabsModule, MatTooltipModule } from "@angular/material";
import { ClientOrderService } from "./clientorderreport/clientorderreport.service";

import { AdminTradeMasterReportComponent } from "./admintrademaster/admintrademaster.component";
import { EditAdminTradeMasterDialog } from "./admintrademaster/edit-admin-trade-master/edit-admin-trade-master.component";

import { ClientTradeReportComponent } from "./clienttradereport/clienttradereport.component";
import { FireblockVaultComponent } from "./fireblockvault/fireblockvault.component";
import { FireblockService } from "./fireblockvault/fireblockvault.service";
import { FireblockAuditComponent } from "./fireblockaudit/fireblockaudit.component";
import { ExchangeTradeReportComponent } from "./exchangetradereport/exchangetradereport.component";
import { PositionBookComponent } from "./positionbook/positionbook.component";
import { ClearJunctionAuditComponent } from "./clearjunctionaudit/clearjunctionaudit.component";
import { ProperJsonDialogComponent } from "./properJsonDialog/properjsondialog.component";
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { whitelistedAddressComponent } from "./whitelistedAddress/whitelistedaddress.component";
import { depositAddressComponent } from "./deposit-address/deposit-address.component";
import { AddClientTrade } from "./addclienttrade/addclienttrade.component";
import { AddExchangeTrade } from "./addexchangetrade/addexchangetrade.component";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { GetinTouchReportComponent } from "./getintouch/getintouch.component";
import { ClearJunctionTransactionsComponent } from "./clearjunctiontransactions/clearjunctiontransaction.component";
import { ClearJunctionService } from "./services/clearjunction.service";
import { EditClearJTransactions } from "./editclearJtransactions/editclearJtransactions.component";
import { FireblockTransactionsComponent } from "./fireblocktransactions/fireblocktransactions.component";
import { FireblockSyncComponent } from "./fireblocksync/fireblocksync.component";
import { FiatWithdrawRejectDialog } from "./fiatrejectconfirm/fiatwithdrawrejectconfirm.component";
import { FiatDepositConfirmDialog } from "./fiatdepositconfirmdialog/fiatdepositconfirmdialog.component";
import { ExchangeDepositComponent } from "./exchangedeposit/exchangedeposit.component";
import { ExchangeWithdrawalComponent } from "./exchangewithdrawal/exchangewithdrawal.component";
import { CustomerListComponent } from "./customerlist/customerlist.component";
import { AddEditCustomers } from "./addeditcustomer/addeditcustomer.component";
import { SidebarSubmenuComponent } from "./sidebar-submenu/sidebar-submenu.component";
import { AddEditSubmenuComponent } from "./addeditsubmenu/addeditsubmenu.component";
import { WalletComponent } from "./wallet/wallet.component";
import { BankComponent } from "./bank/bank.component";
import { AddBankDialog } from "./bank/addbank/addbank.component";
import { AddEditAdminlist } from "./addeditadminlist/addeditadminlist.component";
import { ResetAdminBlockDialog } from "./resetadminblockdialog/resetadminblockdialog.component";
import { MarketPricesComponent } from "./marketprices/marketprices.component";
import { CollateralDepositComponent } from "./collateral-deposit/collateral-deposit.component";
import { EditCollateralDepositDialog } from "./collateral-deposit/edit-collateral-deposit/edit-collateral-deposit.component";
import { MultiplierDialog } from "./collateral-deposit/multiplier/multiplier.component";
import { SumsubAuditComponent } from "./sumsubaudit/sumsubaudit.component";
import { ClientAssetReportComponent } from "./clientassetreport/clientassetreport.component";
import { AddExchangeWithdrawal } from "./exchangewithdrawal/addexchangewithdrawal/addexchangewithdrawal.component";
import { AMLBotAuditComponent } from "./amlbotaudit/amlbotaudit.component";
import { AddEditMarketPrice } from "./marketprices/addeditmarketprices/addeditmarketprices.component";

import { EquitasBankAuditComponent } from "./equitasbankaudit/equitasbankaudit.component";
import { EquitasBankTransactionsComponent } from "./equitasbanktransactions/equitasbanktransaction.component";
import { EquitasBankService } from "./services/equitasbank.service";

import { IndusindBankAuditComponent } from "./indusindbankaudit/indusindbankaudit.component";
import { IndusindBankTransactionsComponent } from "./indusindbanktransactions/indusindbanktransaction.component";
import { IndusindBankService } from "./services/indusindbank.service";
import { EditIndusindBankTransactionDialog } from './indusindbanktransactions/edit-indusind-bank-transaction/edit-indusind-bank-transaction.component';

import { WithdrawBatchComponent } from "./withdraw-batch/withdrawbatch.component";

import { AutoWithdrawalComponent } from "./autowithdrawal/autowithdrawal.component";
import { AddAutoWithdrawal } from "./autowithdrawal/addautowithdrawal/addautowithdrawal.component";
import { AutoWithdrawService } from "./services/autowithdraw.service";
import { HypervergeKYCAuditComponent } from "./hypervergekycaudit/hypervergekycaudit.component";
import { PdfViewerComponent } from "./pdfviewer/pdfviewer.component";

import { SettlementComponent } from "./settlement/settlement.component";
import { SettlementService } from "./settlement/settlement.service";
import { LoginLogsComponent } from "./loginlogs/loginlogs.component";
import { AgGridModule } from 'ag-grid-angular';
import { EmailValidateAuditComponent } from "./emailvalidateaudit/emailvalidateaudit.component";
import { EmailValidateService } from "./services/emailvalidate.service";
import { ClientTransactionsComponent } from "./client-transactions/client-transactions.component";
import { AddEditDepositDialog } from "./client-transactions/add-deposit/add-deposit.component";
import { SentReceiveINRDialog } from "./client-transactions/sent-receive-inr/sent-receive-inr.component";
import { TransactionsReportComponent } from "./transactionsreport/transactionsreport.component";
import { PayoutComponent } from "./payout/payout.component";
import { PayoutOrdersComponent } from "./payout-orders/payout-orders.component";
import { PayoutQuotesComponent } from "./payout-quotes/payout-quotes.component";
import { PayoutCustomersComponent } from "./payout-customers/payout-customers.component";
import { PayoutSettlementsComponent } from "./payout-settlements/payout-settlements.component";
import { OfframpTradesComponent } from "./offramp-trades/offramp-trades.component";
import { AddOfframpTradeDialog } from "./offramp-trades/add-offramp-trade/add-offramp-trade.component";
import { BulkUploadOfframpTradeDialog } from "./offramp-trades/bulk-upload-offramp-trade/bulk-upload-offramp-trade.component";
import { OfframpDailySummaryComponent } from "./offramp-daily-summary/offramp-daily-summary.component";
import { EditOfframpDailySummaryDialog } from "./offramp-daily-summary/edit-offramp-daily-summary/edit-offramp-daily-summary.component";
import { OfframpDailyLogComponent } from "./offramp-daily-log/offramp-daily-log.component";
import { OfframpCryptoReceivedComponent } from "./offramp-crypto-received/offramp-crypto-received.component";
import { AddOfframpCryptoReceivedDialog } from "./offramp-crypto-received/add-offramp-crypto-received/add-offramp-crypto-received.component";
import { OfframpDailyReportComponent } from "./offramp-daily-report/offramp-daily-report.component";
import { OfframpMonitorComponent } from "./offramp-monitor/offramp-monitor.component";
import { OfframpClientQuotesComponent } from "./offramp-client-quotes/offramp-client-quotes.component";
import { AddOfframpClientQuoteDialog } from "./offramp-client-quotes/add-offramp-client-quote/add-offramp-client-quote.component";
import { OfframpExchangeQuotesComponent } from "./offramp-exchange-quotes/offramp-exchange-quotes.component";
import { AddOfframpExchangeQuoteDialog } from "./offramp-exchange-quotes/add-offramp-exchange-quote/add-offramp-exchange-quote.component";
import { OfframpClientsComponent } from "./offramp-clients/offramp-clients.component";
import { AddOfframpClientDialog } from "./offramp-clients/add-offramp-client/add-offramp-client.component";
import { OfframpExchangesComponent } from "./offramp-exchanges/offramp-exchanges.component";
import { AddOfframpExchangeDialog } from "./offramp-exchanges/add-offramp-exchange/add-offramp-exchange.component";
import { OfframpBanksComponent } from "./offramp-banks/offramp-banks.component";
import { AddOfframpBankDialog } from "./offramp-banks/add-offramp-bank/add-offramp-bank.component";
import { OfframpPayoutRechargesComponent } from "./offramp-payout-recharges/offramp-payout-recharges.component";
import { AddOfframpPayoutRechargeDialog } from "./offramp-payout-recharges/add-offramp-payout-recharge/add-offramp-payout-recharge.component";
import { OfframpExchangeWithdrawalsComponent } from "./offramp-exchange-withdrawals/offramp-exchange-withdrawals.component";
import { AddOfframpExchangeWithdrawalDialog } from "./offramp-exchange-withdrawals/add-offramp-exchange-withdrawal/add-offramp-exchange-withdrawal.component";
import { OfframpExchangeDepositsComponent } from "./offramp-exchange-deposits/offramp-exchange-deposits.component";
import { AddOfframpExchangeDepositDialog } from "./offramp-exchange-deposits/add-offramp-exchange-deposit/add-offramp-exchange-deposit.component";
import { OfframpPayoutGatewaysComponent } from "./offramp-payout-gateways/offramp-payout-gateways.component";
import { AddOfframpPayoutGatewayDialog } from "./offramp-payout-gateways/add-offramp-payout-gateway/add-offramp-payout-gateway.component";
import { PayoutTopupComponent } from "./payout-topup/payout-topup.component";
import { PayoutWalletComponent } from "./payout-wallet/payout-wallet.component";
import { AdjustPayoutWalletDialog } from "./payout-wallet/adjust-payout-wallet/adjust-payout-wallet.component";
import { PayoutLedgerComponent } from "./payout-ledger/payout-ledger.component";
import { GatewayWalletComponent } from "./gateway-wallet/gateway-wallet.component";
import { AdjustGatewayWalletDialog } from "./gateway-wallet/adjust-gateway-wallet/adjust-gateway-wallet.component";
import { GatewayDepositsComponent } from "./gateway-deposits/gateway-deposits.component";
import { AddGatewayDepositDialog } from "./gateway-deposits/add-gateway-deposit/add-gateway-deposit.component";
import { PayoutSummaryComponent } from "./payout-Summary/payout-summary.component";
import { OfframpBalanceComponent } from "./offramp-balance/offramp-balance.component";
import { PayoutDailyMetricsComponent } from "./payout-daily-metrics/payout-daily-metrics.component";
import { AddPayoutTopupDialog } from "./payout-topup/add-payout-topup/add-payout-topup.component";
import { AddEditPayoutOrderDialog } from "./payout-orders/add-edit-payout-order/add-edit-payout-order.component";
import { PayoutReportHistoryDialogComponent } from "./payout-orders/payout-report-history-dialog/payout-report-history-dialog.component";
import { PayoutErrorReportDialogComponent } from "./payout-orders/payout-error-report-dialog/payout-error-report-dialog.component";
import { WebhookResponsesComponent } from "./webhook-responses/webhook-responses.component";
import { PayoutCallbackComponent } from "./payout-callback/payout-callback.component";
import { S3ReportsComponent } from "./s3-reports/s3-reports.component";
import { OfframpAdminConfigComponent } from "./offramp-admin-config/offramp-admin-config.component";
import { EditOfframpAdminConfigDialog } from "./offramp-admin-config/edit-offramp-admin-config/edit-offramp-admin-config.component";
import { OfframpCapitalAllocationComponent } from "./offramp-capital-allocation/offramp-capital-allocation.component";
import { AddOfframpCapitalAllocationDialog } from "./offramp-capital-allocation/add-offramp-capital-allocation/add-offramp-capital-allocation.component";
import { OfframpExpensesComponent } from "./offramp-expenses/offramp-expenses.component";
import { AddOfframpExpenseDialog } from "./offramp-expenses/add-offramp-expense/add-offramp-expense.component";
import { OfframpAddressMappingsComponent } from "./offramp-address-mappings/offramp-address-mappings.component";
import { AddOfframpAddressMappingDialog } from "./offramp-address-mappings/add-offramp-address-mapping/add-offramp-address-mapping.component";
import { SecuirtyService } from "./services/secuirty.service";

@NgModule({
  declarations: [
    AppComponent,
    ApploginComponent,
    IndexComponent,
    AppcustomerlistComponent,
    AppkycdetailsComponent,
    TransactionsComponent,
    FiatTransactionsComponent,
    LoginactivityComponent,
    AdminTransactionsComponent,
    WithdrawComponent,
    FiatWithdrawComponent,
    OrderComponent,
    ManageadminComponent,
    GroupsComponent,
    SidebarComponent,
    HeaderComponent,
    ContentComponent,
    FooterComponent,
    MobilesidebarComponent,
    AnnouncementComponent,
    TradereportComponent,
    SecuirtiesComponent,
    MenupermissionPipe,
    KycplansComponent,
    PayoutComponent,
    PayoutOrdersComponent,
    PayoutQuotesComponent,
    PayoutCustomersComponent,
    PayoutSettlementsComponent,
    OfframpTradesComponent,
    AddOfframpTradeDialog,
    BulkUploadOfframpTradeDialog,
    OfframpDailySummaryComponent,
    EditOfframpDailySummaryDialog,
    OfframpDailyLogComponent,
    OfframpCryptoReceivedComponent,
    AddOfframpCryptoReceivedDialog,
    OfframpDailyReportComponent,
    OfframpMonitorComponent,
    OfframpClientQuotesComponent,
    AddOfframpClientQuoteDialog,
    OfframpExchangeQuotesComponent,
    AddOfframpExchangeQuoteDialog,
    OfframpClientsComponent,
    AddOfframpClientDialog,
    OfframpExchangesComponent,
    AddOfframpExchangeDialog,
    OfframpBanksComponent,
    AddOfframpBankDialog,
    OfframpPayoutRechargesComponent,
    AddOfframpPayoutRechargeDialog,
    OfframpExchangeWithdrawalsComponent,
    AddOfframpExchangeWithdrawalDialog,
    OfframpExchangeDepositsComponent,
    AddOfframpExchangeDepositDialog,
    OfframpPayoutGatewaysComponent,
    AddOfframpPayoutGatewayDialog,
    PayoutTopupComponent,
    PayoutWalletComponent,
    AdjustPayoutWalletDialog,
    PayoutLedgerComponent,
    GatewayWalletComponent,
    AdjustGatewayWalletDialog,
    GatewayDepositsComponent,
    AddGatewayDepositDialog,
    PayoutSummaryComponent,
    OfframpBalanceComponent,
    PayoutDailyMetricsComponent,
    AddPayoutTopupDialog,
    AddEditPayoutOrderDialog,
    PayoutReportHistoryDialogComponent,
    PayoutErrorReportDialogComponent,
    WebhookResponsesComponent,
    PayoutCallbackComponent,
    S3ReportsComponent,
    OfframpAdminConfigComponent,
    EditOfframpAdminConfigDialog,
    OfframpCapitalAllocationComponent,
    AddOfframpCapitalAllocationDialog,
    OfframpExpensesComponent,
    AddOfframpExpenseDialog,
    OfframpAddressMappingsComponent,
    AddOfframpAddressMappingDialog,
    SumValuesPipe,
    TransferComponent,
    ConfirmationDialogComponent,
    ManageAuctionConfigurationComponent,
    AdmintradereportComponent,
    ManageipComponent,
    CmsComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    GeneratePasswordComponent,
    LinkexpireComponent,
    ManualkycComponent,
    ReferralconfigComponent,
    ReferalhistoryComponent,
    ReferralbonustransComponent,
    CareersComponent,
    ContentManagementComponent,
    CandidatesComponent,
    HomeComponent,
    ManageAddressWhitelistComponent,
    LedgerComponent,
    ClientOrderReportComponent,
    AdminTradeMasterReportComponent,
    EditAdminTradeMasterDialog,
    ClientTradeReportComponent,
    FireblockVaultComponent,
    ConfirmationDialogComponent,
    FireblockAuditComponent,
    ExchangeTradeReportComponent,
    PositionBookComponent,
    ClearJunctionAuditComponent,
    ProperJsonDialogComponent,
    whitelistedAddressComponent,
    depositAddressComponent,
    AddClientTrade,
    AddExchangeTrade,
    GetinTouchReportComponent,
    ClearJunctionTransactionsComponent,
    EditClearJTransactions,
    FireblockTransactionsComponent,
    FireblockSyncComponent,
    FiatWithdrawRejectDialog,
    FiatDepositConfirmDialog,
    ExchangeDepositComponent,
    ExchangeWithdrawalComponent,
    CustomerListComponent,
    AddEditCustomers,
    SidebarSubmenuComponent,
    AddEditSubmenuComponent,
    WalletComponent,
    BankComponent,
    AddBankDialog,
    AddEditAdminlist,
    ResetAdminBlockDialog,
    MarketPricesComponent,
    CollateralDepositComponent,
    EditCollateralDepositDialog,
    MultiplierDialog,
    SumsubAuditComponent,
    ClientAssetReportComponent,
    AddExchangeWithdrawal,
    AMLBotAuditComponent,
    AddEditMarketPrice,
    EquitasBankAuditComponent,
    EquitasBankTransactionsComponent,
    IndusindBankAuditComponent,
    IndusindBankTransactionsComponent,
    WithdrawBatchComponent,
    EditIndusindBankTransactionDialog,
    AutoWithdrawalComponent,
    AddAutoWithdrawal,
    HypervergeKYCAuditComponent,
    PdfViewerComponent,
    SettlementComponent,
    EmailValidateAuditComponent,
    LoginLogsComponent,
    ClientTransactionsComponent,
    AddEditDepositDialog,
    SentReceiveINRDialog,
    TransactionsReportComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SimpleNotificationsModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    ClipboardModule,
    AgGridModule.withComponents([]),
    Ng2TelInputModule,
    AngularDateTimePickerModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    RichTextEditorAllModule,
    NgMultiSelectDropDownModule.forRoot(),
    MaterialModule,
    CKEditorModule,
    AngularMultiSelectModule,
    MatTableModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSortModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatCardModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    NgxJsonViewerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatIconModule
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchsitekey,
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionExpiredInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientIpInterceptor,
      multi: true,
    },
    ClientIpService,
    UserService,
    SecuirtyService,
    RoutingstateService,
    KycserviceService,
    PuserserviceService,
    AssetsService,
    PagerserviceService,
    WalletsService,
    TransactionService,
    BankService,
    OfframpService,
    ConfigurationService,
    ExchangeService,
    TradingService,
    AdminService,
    AnnouncementService,
    Globals,
    ReportService,
    FileService,
    ViewsService,
    CareerService,
    HomeService,
    ContentManagementService,
    AppKycDetailsService,
    AppCustomerService,
    ClientOrderService,
    FireblockService,
    ClearJunctionService,
    EquitasBankService,
    IndusindBankService,
    AutoWithdrawService,
    SettlementService,
    EmailValidateService
  ],
  entryComponents: [
    ConfirmationDialogComponent,
    AdjustPayoutWalletDialog,
    AdjustGatewayWalletDialog,
    AddGatewayDepositDialog,
    AddClientTrade,
    ProperJsonDialogComponent,
    AddExchangeTrade,
    EditClearJTransactions,
    FiatWithdrawRejectDialog,
    FiatDepositConfirmDialog,
    AddEditCustomers,
    AddEditMarketPrice,
    AddEditSubmenuComponent,
    AddEditAdminlist,
    ResetAdminBlockDialog,
    EditCollateralDepositDialog,
    EditAdminTradeMasterDialog,
    MultiplierDialog,
    AddExchangeWithdrawal,
    AddBankDialog,
    EditIndusindBankTransactionDialog,
    AddAutoWithdrawal,
    PdfViewerComponent,
    AddEditDepositDialog,
    SentReceiveINRDialog,
    AddOfframpTradeDialog,
    BulkUploadOfframpTradeDialog,
    EditOfframpDailySummaryDialog,
    AddOfframpCryptoReceivedDialog,
    AddOfframpClientQuoteDialog,
    AddOfframpExchangeQuoteDialog,
    AddOfframpClientDialog,
    AddOfframpExchangeDialog,
    AddOfframpBankDialog,
    AddOfframpPayoutRechargeDialog,
    AddOfframpExchangeWithdrawalDialog,
    AddOfframpExchangeDepositDialog,
    AddOfframpPayoutGatewayDialog,
    AddPayoutTopupDialog,
    AddEditPayoutOrderDialog,
    PayoutReportHistoryDialogComponent,
    PayoutErrorReportDialogComponent,
    EditOfframpAdminConfigDialog,
    AddOfframpCapitalAllocationDialog,
    AddOfframpExpenseDialog,
    AddOfframpAddressMappingDialog
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts